import script from "./Address.vue?vue&type=script&setup=true&lang=js"
export * from "./Address.vue?vue&type=script&setup=true&lang=js"

import "./Address.vue?vue&type=style&index=0&id=61a779c3&lang=scss&scoped=true"

import exportComponent from "E:\\东智商户端源码\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a779c3"]])

export default __exports__